import React from "react"
import Typography from "@material-ui/core/Typography"
import useStyles from "./css"
import DashboardElement from "../component/widgets/dashboard/DashboardElement"

export default function FundSummaryTitle(props) {
  const classes = useStyles()

  return (
    <DashboardElement
      data={props}
      TextProps={{
        showTitle: false,
        component: "span",
        id: "fundSummaryTitle",
        renderText: (_, text) => (
          <Typography className={classes.fundSummaryTitle} component="span">
            {text}
          </Typography>
        ),
        onEmpty: () => null
      }}
    />
  )
}
